import React, { Component } from 'react';
import { Popover, Icon, message, Checkbox, Modal } from 'antd';
import { GETSTOREFILTER_URL } from '../../../utils/config';

import './FilterHeader.css';

export default class FilterHeader extends Component {
  state = {
    data: {},
    selectedRegion: [],
    buttonStyle: {
      backgroundImage: 'linear-gradient(to bottom, #fcfcfd, #e7e9ec 100%)'
    },
    checkedList: [],
    visible: false,
  };

  componentDidMount() {
    fetch(GETSTOREFILTER_URL, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(data => {
        this.setState({ data });
      })
      .catch(err => {
        message.error(String(err));
      })
  }

  handleClickRegion = (item) => {
    let selectedRegion = this.state.selectedRegion;
    if (this[item].style.color === 'rgb(255, 255, 255)') {
      // 取消选择
      const index = selectedRegion.indexOf(item);
      selectedRegion.splice(index, 1);
    } else {
      // 选择
      selectedRegion.push(item);
    }
    this.setState({
      selectedRegion,
    });
  };

  handleClean() {
    this.setState({
      selectedRegion: [],
      checkedList: [],
    });
    this.props.apply([], []);
  };

  handleDelete = (item, type) => {
    const selectedRegion = this.state.selectedRegion;
    const checkedList = this.state.checkedList;
    if (type === 'region') {
      const index = selectedRegion.indexOf(item);
      selectedRegion.splice(index, 1);
    } else {
      const index = checkedList.indexOf(item);
      checkedList.splice(index, 1);
    }
    this.setState({
      selectedRegion,
      checkedList,
    });
    this.applyFilter();
  };

  handleCheckboxChange = (checkedList) => {
    this.setState({ checkedList });
  };

  applyFilter = () => {
    if (this.state.selectedRegion.length === 0 && this.state.checkedList.length !== 0) {
      this.props.apply(this.state.data.regions, this.state.checkedList)
    }
    if (this.state.selectedRegion.length !== 0 && this.state.checkedList.length === 0) {
      this.props.apply(this.state.selectedRegion, this.state.data.categories);
    }
    if ((this.state.selectedRegion.length !==0 && this.state.checkedList.length !== 0) || (this.state.selectedRegion.length ===0 && this.state.checkedList.length === 0)) {
      this.props.apply(this.state.selectedRegion, this.state.checkedList);
    }
    this.handleCancel();
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const filterColor = this.state.selectedRegion.length !== 0 || this.state.checkedList.length !== 0 ? '#e2af59' : '#222f3f';
    const menu = (
      <div className="filter-menu">
        <div className="left">
          <h5>Region</h5>
          <div className="regions">
            {this.state.data.regions !== undefined && this.state.data.regions.map((item, index) => {
              return <span
                key={index}
                className="region"
                ref={(c) => this[item] = c}
                style={this.state.selectedRegion.includes(item) ? {
                  backgroundColor: '#222f3f',
                  color: '#fff'
                } : {
                  backgroundColor: '#f5f5f5',
                  color: '#000'
                }}
                onClick={this.handleClickRegion.bind(this, item)}
              >
                {item}
              </span>
            })}
          </div>
        </div>
        <div className="right">
          <h5>Category</h5>
          <div className="categories">
            <Checkbox.Group
              options={this.state.data.categories}
              value={this.state.checkedList}
              onChange={this.handleCheckboxChange.bind(this)}
            />
          </div>
        </div>
      </div>
    );

    const modalFooter = <div className="modalFooter">
      <span className="clean-all" onClick={this.handleClean.bind(this)}>Clean All</span>
      <span className="apply" onClick={this.applyFilter.bind(this)}>Apply</span>
    </div>;
    return (
      <div className="FilterHeader">
        <div className="desktop" id="FilterHeader">
          <Popover
            content={menu}
            trigger='click'
            getTooltipContainer={() => document.getElementById('FilterHeader')}
            placement="bottomLeft"
          >
            <div className="filter-button" style={{ borderBottomColor: filterColor }}>
              <Icon type="filter" style={{ fontSize: 14, color: filterColor }} />
              <span style={{ color: filterColor }}>Filter</span>
              <Icon type="caret-down" style={{ fontSize: 10, color: filterColor }} />
            </div>
          </Popover>

          <div className="selected-tags">
            {this.state.selectedRegion !== undefined && this.state.selectedRegion.map((item, index) => {
              return <span
                key={index}
                className="tag"
                ref={(c) => this[item] = c}
                onClick={this.handleDelete.bind(this, item, 'region')}
              >{item}</span>
            })}
            {this.state.checkedList !== undefined && this.state.checkedList.map((item, index) => {
              return <span
                key={index}
                className="tag"
                ref={(c) => this[item] = c}
                onClick={this.handleDelete.bind(this, item, 'category')}
              >{item}</span>
            })}
          </div>

          <div className="operation-area">
            <span className="clean-all" onClick={this.handleClean.bind(this)}>Clean All</span>
            <span
              className="apply"
              style={this.state.selectedRegion.length !== 0 || this.state.checkedList.length !== 0 ? {backgroundImage: 'linear-gradient(to bottom, #f8df9d, #f1c240)'} : {}}
              onClick={this.applyFilter.bind(this)}
            >APPLY</span>
          </div>
        </div>
        <div className="mobile">
          <div className="filter-button" onClick={this.showModal.bind(this)}>
            <Icon type="filter" style={{ fontSize: 14, color: filterColor }} />
            <span style={{ color: filterColor }}>Filter</span>
            <Icon type="caret-down" style={{ fontSize: 10, color: filterColor }} />
          </div>
          <Modal
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            wrapClassName="vertical-center-modal"
            className="filter-modal"
            footer={modalFooter}
          >
            <div className="top">
              <h5>Region</h5>
              <div className="regions">
                {this.state.data.regions !== undefined && this.state.data.regions.map((item, index) => {
                  return <span
                    key={index}
                    className="region"
                    ref={(c) => this[item] = c}
                    style={this.state.selectedRegion.includes(item) ? {
                      backgroundColor: '#222f3f',
                      color: '#fff'
                    } : {
                      backgroundColor: '#f5f5f5',
                      color: '#47566a'
                    }}
                    onClick={this.handleClickRegion.bind(this, item)}
                  >
                    {item}
                  </span>
                })}
              </div>
            </div>
            <div className="bottom">
              <h5>Category</h5>
              <div className="categories">
                <Checkbox.Group
                  options={this.state.data.categories}
                  value={this.state.checkedList}
                  onChange={this.handleCheckboxChange.bind(this)}
                />
              </div>
              <div className="white" />
            </div>
          </Modal>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Containers/Stores/components/FilterHeader.js